import React from "react";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

export default function Manual() {
  return (
    <div>
      <br />
      <h2>Videotutoriales</h2>
      <Typography
        style={{ margin: "auto", fontSize: "20px" }}
        variant="h1"
        component="h2"
        variant="caption"
        display="block"
        gutterBottom
      >
        Para brindar apoyo sobre el uso del sistema y a sus funcionalidades en
        distintos flujos de procedimientos, se tiene como material de apoyo,
        videos con instrucciones practicas, que sirven de capacitacion y
        autoaprendizaje.
      </Typography>
      <br />
      <Link
        href="https://drive.google.com/open?id=1n0NPY3ig1bmln2pCFBJ95zakrR6MkNn6"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Envio de solicitudes (Cliente)
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1y5nMpMdgl9VMg2kuu2mT8stIeLsG7PZ9"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Consulta de Caso (Cliente)
        </Typography>
      </Link>
      <br />
      <Link
        href="https://drive.google.com/open?id=1ovtA8UOF93W3BjQ40ZPBFevXYUFyioF6"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Configuracion
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1sQY-BFnC-ordNEalOCZZxcEJDTS3tmmn"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Catalogos
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=10du5y7twEPoxE7BjR7ykK8q11E8RnpLg"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Usuarios y Privilegios
        </Typography>
      </Link>
      <br />
      <Link
        href="https://drive.google.com/open?id=1jXokkquqixgxK6qye4Fg1xveEqcbt_-U"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Inicio de Sesion - Pantalla Principal
        </Typography>
      </Link>

      <Link
        href="https://drive.google.com/open?id=15vGXZs9OTs9HFyeg2IrjXLQ99lDAkDlN"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Solicitudes
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1YKiqtyTKwltwBcdmDSTVGbJvg5ZnxeN_"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Casos
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1y86qh5etOEg-vmn1pOpZ_SwoYI_j8oq1"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento Asignado
        </Typography>
      </Link>
      <br />

      <Link
        href="https://drive.google.com/open?id=1TuSDXndwi-wnJvLEEp6gk7aOqrxZ5NUY"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte General
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=17dJU_9BCr-Ci8HpFnr2_yHf6adaOVTfR"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte Amparos Resueltos
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1gPzp_7HdZh_vdqhouSriu_S7uDiWoC4h"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte Apelacion
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1Ql9tj4UZDFO_oozoQ57Y6dMoQNMxljxf"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte Monto y Cuantias
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1QJsKNx94f3B5Z24RUXOmfdcdxrN72PzU"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte Usuario
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1J5PLnawOkV2TEUyvUhXOxlA-Xl00eghT"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte Tipo Materia
        </Typography>
      </Link>
      <Link
        href="https://drive.google.com/open?id=1XGLZ9Zqb_DxgVLLed3fE_KWe6_LEFpt4"
        target="_blank"
      >
        <Typography
          style={{ margin: "auto", fontSize: "20px" }}
          variant="h1"
          component="h2"
          variant="caption"
          display="block"
          gutterBottom
        >
          Procediemiento de Reporte Fechas Futuras
        </Typography>
      </Link>
    </div>
  );
}
